import React, { useCallback, useReducer } from 'react';
import Swal from 'sweetalert2';
import { Box, Card, CardContent, Typography, Tab, Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import connectionService from "../../services/Connection";
import util from '../../util/index';
import strings from "../../Globalization/index";
import consts from '../../consts';
import { CustomMuiTabs } from './Tabs';
import VideoPlayer from './VideoPlayer';

const TabPanel = ({ children, value, currentValue, sx = {}, ...other }) => {
	return (
		<div role="tabpanel" hidden={value !== currentValue} {...other}>
			{value === currentValue && (
				<Box sx={sx}>
					{children}
				</Box>
			)}
		</div>
	);
};

const VideoList = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { auth } = useSelector(storeState => storeState);
	const isCatEndo = auth?.tags?.LicenseAppName?.includes('catendo');
	const isCatViewer = auth?.tags?.LicenseAppName?.includes('catviewer')
	const [state, setState] = useReducer((prev, next) => (typeof next === 'function' ? { ...prev, ...next(prev) } : { ...prev, ...next }), {
		videoUrl: null,
		activeIndex: 0,
	});
	const tabValue = searchParams.get('tab') ? searchParams.get('tab') : isCatViewer ? '1' : '2';
	const viewerList = util.GetViewerVideoList();
	const endoList = util.getEndoVideoList();

	const handleChange = (event, newValue) => {
		setSearchParams({ 'tab': newValue });
		setState({ ...state, videoUrl: '', activeIndex: 0 });
	};
	const loadHelpVideo = useCallback(async (videoName, index) => {
		let formData = new FormData();
		formData.append('action', 'loadVideoUrl');
		formData.append('videoName', videoName);
		formData.append('preferredLang', consts.languageMapper[util.localData.PTXPreferredLang]);

		try {
			const response = await fetch(connectionService.HelpVideo, {
				method: 'POST',
				body: formData,
				credentials: 'include'
			});

			if (response.status === 200) {
				const text = await response.text();
				const json = util.unsafeJson(text);

				if (json.success) {
					// Use the full URL from the API response (includes correct host for both local and Azure)
					setState((prev) => ({ ...prev, videoUrl: json.videoUrl }));
					setState((prev) => ({ ...prev, activeIndex: index }));
				} else {
					Swal.fire({ titleText: strings.ErrorTitle, text: strings.ErrorReadingFile, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
				}
			}
		} catch (err) {
			Swal.fire({ titleText: strings.ErrorTitle, text: strings.ErrorReadingFile, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
		}
	}, []);

	const getVideo = (videoName, index) => {
		loadHelpVideo(videoName, index);
	};
	const renderItem = (index, name, videoName) => {
		let defaultClass = "font-bold video_list";
		return (
			<Grid
			    key={`key_${index}`}
				size="auto"
				id={index}
				data-name={strings[name]}
				data-videoname={videoName}
				onClick={() => getVideo(videoName, index)}
				onContextMenu={(event) => onClick(videoName, event)}
				className={state.activeIndex === index ? defaultClass + " video_list_active" : defaultClass}
				sx={{
					mx: 1,
					my: 0.5,
					width: '90%',
					'& .video_list_active': {
						color: 'primary.main',
					},
					padding: theme => theme.spacing(1)
				}}
			>
				<span id="clickable-area" className="font-bold">{strings[name]}</span>
			</Grid>
		);
	};

	const onClick = (videoname, event) => {
		event.preventDefault();
		let url = connectionService.HelpVideo + "?action=videoRedirect&videoName=" + videoname + "&preferredLang=" + consts.languageMapper[util.localData.PTXPreferredLang]
		window.open(url + "&redirect=true", "_blank", "width=500,height=500");
	};
	return (
		<Grid>
			<Card sx={{
				width: '100%',
				height: '100%',
				'& .MuiCardContent-root': {
					padding: '0px',
				},
				marginBottom: theme => theme.spacing(2)
			}}
			>
				<CardContent sx={{ p: (theme) => `${theme.spacing(1.5)} !important` }}>
					<Typography variant="h5" color="primary">{strings.TrainingVideos}</Typography>
				</CardContent>
			</Card>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<CustomMuiTabs onChange={handleChange} value={tabValue} >
						{isCatViewer && <Tab label={strings.Catviewer} value="1" />}
						{isCatEndo && <Tab label={strings.Catendo} value="2" />}
					</CustomMuiTabs>
				</Box>
				{isCatViewer &&
					<TabPanel value="1" currentValue={tabValue} sx={{ backgroundColor: '#fff', borderRadius: 1 }}>
						<Grid container direction="row">
							<Grid container direction="column" size={4}>
								{Object.keys(viewerList).map((key) => {
									const data = viewerList[key];
									return renderItem(data.Index, key, data.videoName);
								})}
							</Grid>
							<Grid size={8}>
								<VideoPlayer videoUrl={state.videoUrl} />
							</Grid>
						</Grid>
					</TabPanel>}
				{isCatEndo && <TabPanel value="2" currentValue={tabValue} sx={{ backgroundColor: '#fff', borderRadius: 1 }}>
					<Grid container direction="row">
						<Grid container direction="column" size={4}>
							{Object.keys(endoList).map((key) => {
								const data = endoList[key];
								return renderItem(data.Index, key, data.videoName);
							})}
						</Grid>
						<Grid size={8}>
							<VideoPlayer videoUrl={state.videoUrl} />
						</Grid>
					</Grid>
				</TabPanel>
				}
		</Grid>
	)


};


export default VideoList;